import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectSignStatus = createSelector(
  [(store: RootState) => store.documentSignerShow.signStatus],
  (signStatus) => signStatus
);
